import { ACQUISITION_BONUS_INFO_BAR_BANNER_VIEW } from './types';

export const triggerAcquisitionBonusInfoBarBannerViewed = () => ({
  type: ACQUISITION_BONUS_INFO_BAR_BANNER_VIEW,
});
